import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import Button from '../Button';
import { isPick7iOSWebView } from '../../utils/authUtils';

const PlayItv = ({ titleText, buttonText, TermsLink, ButtonLink }) => {
    return (
        <Styled.Wrapper>
            <Styled.Title>{titleText}</Styled.Title>
            {isPick7iOSWebView() ? (
                <Styled.Body>
                    Head back to the homepage for more chances to win!
                </Styled.Body>
            ) : (
                <Styled.Body>
                    Why not play <strong>ITV7</strong> for more chances to win!
                </Styled.Body>
            )}
            {!isPick7iOSWebView() && (
                <Styled.ButtonWrapper>
                    <ButtonLink>
                        <Button
                            type="default"
                            buttonText={buttonText}
                            disabled={false}
                        />
                    </ButtonLink>
                </Styled.ButtonWrapper>
            )}
            <Styled.Terms>Opening times may be subject to change.</Styled.Terms>
            <TermsLink>
                <Styled.TermsLink>
                    18+ and UK only, T&Cs apply, see here.
                </Styled.TermsLink>
            </TermsLink>
        </Styled.Wrapper>
    );
};

PlayItv.propTypes = {
    titleText: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    TermsLink: PropTypes.func.isRequired,
    ButtonLink: PropTypes.func.isRequired
};

export default PlayItv;
